export default __webpack_public_path__ + "static/media/password.d02a5cf3.svg";